import { LOG_LEVEL_STYLE, LogLevel } from "./logger.models";

const noop = (): any => undefined;
export class Logger {
    private _logPrefix = "%c<<MNG_Plugins>>";
    private _className: string = "General";
    private _enabled: boolean = true;
    private _logLevel: LogLevel = LogLevel.Debug;
    private _style: string = "";

    constructor(className: string, enabled: boolean, logLevel: LogLevel, style?: any) {
        // console.log("Logger.CTOR", className, enabled, logLevel, style);
        this._className = className;
        this._enabled = enabled;
        this._logLevel = logLevel;
        this._style = style;
    }

    public setLogPrefix(val: string): void {
        // console.log('Logger.setEnabled == ', clsName, val);
        this._logPrefix = val;
    }

    public setEnabled(val: boolean): void {
        let clsName = this._className;
        //console.log('Logger.setEnabled == ', clsName, val);
        this._enabled = val;
    }

    public setLogLevel(level: LogLevel): void {
        //console.log('Logger.setLogLevel == ', this._className, level);
        this._logLevel = level;
    }

    private format() {
        return this._logPrefix + "[" + this._className + "] ";
    }

    private getStyle(logLevel: LogLevel) {
        let style;
        let bg = "none";
        if (this._style) {
            //console.log("getStyle | has Style");
            style = this._style
            bg = LOG_LEVEL_STYLE[logLevel].bg;
        } else {
            //console.log("getStyle | NO Style");
            style = LOG_LEVEL_STYLE[logLevel].color;
            bg = LOG_LEVEL_STYLE[logLevel].bg;
        }
        //console.log("getStyle | ", "bg", bg, "style ", style);
        return `color: ${style}; background-color: ${bg}; padding: 2px; border-radius: 3px;`
        //return ["color:" + style + ";font-weight:bold;"];
        // return ["color:" + style + ";font-weight:bold;background:" + bg + ";"];
        // return ["color:#004000;font-weight:bold;background:rgba(51, 170, 51, .1)"];
    }

    get debug() {
        if (this.isEnabled(LogLevel.Debug)) {
            return console.debug.bind(console, this.format(), this.getStyle(LogLevel.Debug));
        } else {
            return noop;
        }
    }

    get info() {
        if (this.isEnabled(LogLevel.Info)) {
            return console.info.bind(console, this.format(), this.getStyle(LogLevel.Info));
        } else {
            return noop;
        }
    }

    get warn() {
        if (this.isEnabled(LogLevel.Warn)) {
            return console.warn.bind(console, this.format(), this.getStyle(LogLevel.Warn));
        } else {
            return noop;
        }
    }

    get error() {
        if (this.isEnabled(LogLevel.Error)) {
            return console.error.bind(console, this.format(), this.getStyle(LogLevel.Error));
        } else {
            return noop;
        }
    }

    get fatal() {
        if (this.isEnabled(LogLevel.Fatal)) {
            return console.error.bind(console, this.format(), this.getStyle(LogLevel.Fatal));
        } else {
            return noop;
        }
    }

    get trace() {
        if (this.isEnabled(LogLevel.Trace)) {
            //console.log("this.format()", this.format());
            //console.log("this.getStyle(LogLevel.Trace)", this.getStyle(LogLevel.Trace));
            return console.debug.bind(console, this.format(), this.getStyle(LogLevel.Trace));
        } else {
            return noop;
        }
    }

    /* PRIVATE */
    /*TODO: Create function that creates the preface and also handles console colorize depending on browser (IE does not support colors, so style is printed) */
    private isEnabled(logLevel: LogLevel): boolean {
        //if this_logLevel == info which is
        //console.log(`isEnabled | logLevel: ${logLevel} | this._logLevel: ${this._logLevel} `);
        //console.log("isEnabled", "logLevel", logLevel, "this._logLevel", this._logLevel);
        if (logLevel >= this._logLevel && this._enabled) {
            return true;
        } else {
            return false;
        }
    }
}